module.exports = __webpack_public_path__ + "static/media/Athelas-Bold.9dd70695.svg";